
import InOutMode from '@/Models/Static/InOutMode'

const state = () => ({
  /**
   * In/out dialog visibility.
   * @type Boolean
   */
  show: false,

  /**
   * In/out window-item.
   * @type Number
   */
  step: 0,

  /**
   * In/out mode.
   * @type String
   */
  mode: undefined,
})

const getters = {}

const mutations = {
  show (state) {
    state.show = true
  },
  hide (state) {
    state.show = false
  },
  step (state, v) {
    state.step = v
  },
  mode (state, v) {
    if (v !== undefined && ! InOutMode.valid(v)) {
      throw new Error('Invalid In/Out mode')
    }
    state.mode = v
  },
}

const actions = {
  open ({ commit }) {
    commit('show')
  },
  close ({ commit }) {
    commit('hide')
    setTimeout(() => {
      commit('step', 0)
      commit('mode', undefined)
    }, 200)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
